export default __webpack_public_path__ + "static/media/pic1.cf7d1ac8.jpg";